import { type CellContext } from '@tanstack/react-table';

import { useSidePanel } from 'src/registry/providers/SidePanelProvider';

interface CellActionProps<TData, TValue> extends CellContext<TData, TValue> {
    sidePanelName: string;
    singleRowSelection: (rowId: string) => void;
    render?: (value: TValue, row: TData) => React.ReactNode;
}
export function CellAction<TData, TValue>({
    getValue,
    row,
    sidePanelName,
    singleRowSelection,
    render,
}: CellActionProps<TData, TValue>) {
    const value = getValue();

    const { openPanel } = useSidePanel();

    if (value == null) return null;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        singleRowSelection(row.id.toString());
        openPanel(sidePanelName);
    };

    return (
        <div onClick={handleClick} className="text-primary-700 cursor-pointer font-semibold">
            {render ? render(value, row.original) : String(value)}
        </div>
    );
}
